// extracted by mini-css-extract-plugin
module.exports = {"grid":"FinancePricesSettings_grid__xcYXg","pair":"FinancePricesSettings_pair__17w90","label":"FinancePricesSettings_label__25hwb","oneRow":"FinancePricesSettings_oneRow__3X-oS"};